import ACT, {orderTimeACT as otACT} from '../../constants/vuexActions'
import MUT, {orderTimeMUT as otMUT} from '../../constants/vuexMutations'
import apolloClient from '../../apolloClient'
import statsOWQueries from '../../graphql/statsOrdersWorkshops'
import graphqlStats from '../../constants/graphqlStats'
import {orderTimeGetters as otGET} from '../../constants/vuexGetters'
import moduleDateFilter from '../reusablemodules/dateFilter'
import moduleRestPointFilter from '../reusablemodules/restPointFilter'
import moduleDeliveryTypeFilter from '../reusablemodules/deliveryTypeFilter'

const moduleOrderSummaryTimeStats = {
  namespaced: true,
  state: {
    statsTimeOrder: [],
    loadingOrderTimeStats: true
  },
  actions: {
    async [otACT.REQUEST_INIT_DATA] ({dispatch}) {
      await dispatch(ACT.GET_REST_POINTS)
      await dispatch(ACT.GET_DELIVERY_TYPES)
    },
    [ACT.DATE_UPDATED] ({dispatch}) {
      dispatch(ACT.REQUEST_STATS)
    },
    [ACT.FILTER_UPDATED] ({dispatch}) {
      dispatch(ACT.REQUEST_STATS)
    },
    async [ACT.REQUEST_STATS] ({commit, dispatch, state}) {
      dispatch(otACT.GET_ORDER_TIME_STATS)
    },
    [otACT.GET_ORDER_TIME_STATS] ({commit, state, getters}) {
      commit(otMUT.SET_LOADING_STATS_ORDER_TIME, true)
      apolloClient.query({
        query: graphqlStats.timeOrderStats,
        variables: {
          dateFrom: getters.dateFromForQuery,
          dateTo: getters.dateToForQuery,
          idRestPoint: getters.selectedRestPointForQuery,
          idTypeDelivery: getters.selectedDeliveryTypeForQuery
        }
      }).then(res => {
        commit(otMUT.SET_ORDER_TIME_STATS, res.data.getStatsTimeOrder.nodes)
      }).finally(() => {
        commit(otMUT.SET_LOADING_STATS_ORDER_TIME, false)
      })
    }
  },
  mutations: {
    [otMUT.SET_ORDER_TIME_STATS] (state, stats) {
      state.statsTimeOrder = stats
    },
    [otMUT.SET_LOADING_STATS_ORDER_TIME] (state, payload) {
      state.loadingOrderTimeStats = payload
    }
  },
  getters: {
    statsOrder (state) {
      return state.statsTimeOrder
    },
    statsWorkshop (state) {
      return state.statsWorkshops
    },
    statsStages (state) {
      let resStats = []
      if (state.statsTimeOrder !== null) {
        resStats.push(state.statsTimeOrder)
      }
      resStats = resStats.concat(state.statsWorkshops)
      return resStats
    },
    [otGET.LOADING_STATS_TIME_ORDER] (state, getters) {
      return state.loadingOrderTimeStats
    },
    [otGET.STATS_TIME_ORDER] (state, getters) {
      return state.statsTimeOrder
    }
  },
  modules: {
    dateFilter: moduleDateFilter,
    restPointFilter: moduleRestPointFilter,
    deliveryTypeFilter: moduleDeliveryTypeFilter
  }
}

export default moduleOrderSummaryTimeStats



// WEBPACK FOOTER //
// ./src/vuex/submodules/orderSummaryTimeStats.js